import { render, staticRenderFns } from "./idaripersoneller.vue?vue&type=template&id=c5c37a1e&"
import script from "./idaripersoneller.vue?vue&type=script&lang=js&"
export * from "./idaripersoneller.vue?vue&type=script&lang=js&"
import style0 from "./idaripersoneller.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports